import { useEffect, useState } from "react";
import { producaov2 } from "../../../../../services/apis";
import * as dateFNS from 'date-fns';
import { questionTypes, SURVEY_CONFIG_FIELDS, SURVEY_FORM_FIELDS, SURVEY_QUESTION_FIELDS, surveyStatusOptions } from "../constants";

export default function useFetchSurvey({ surveyID }) {
  const [data, setData] = useState({});
  const [loadingSurvey, setLoadingSurvey] = useState(!!surveyID);
  const [error, setError] = useState('');

  useEffect(() => {
    const getData = async () => {
      try {
        setLoadingSurvey(true);

        const response = await producaov2.get(`/admin/surveys/${surveyID}`, {
          headers: {
            access_token: `voitto-token ${localStorage.getItem('oauth_token')}`
          }
        });

        setData({
          [SURVEY_FORM_FIELDS.TITLE]: response.data.name,
          [SURVEY_FORM_FIELDS.DESCRIPTION]: response.data.description.replace(/<br>/g, '\n'),
          [SURVEY_FORM_FIELDS.STATUS]: surveyStatusOptions.find(status => +status.id === +response.data.status_id),
          [SURVEY_FORM_FIELDS.EXPIRES_IN]: response.data?.expires_in ? dateFNS.format(new Date(response.data.expires_in), 'yyyy-MM-dd') : null,
          [SURVEY_FORM_FIELDS.SLUG]: response.data.url,
          [SURVEY_FORM_FIELDS.TOP_IMAGE_URL]: response.data.top_image_url,
          [SURVEY_FORM_FIELDS.CONFIG]: {
            [SURVEY_CONFIG_FIELDS.USER_INPUTS]: response.data.config.user_inputs,
            [SURVEY_CONFIG_FIELDS.HAS_UNLIMITED_ANSWERS]: response.data.config.has_unlimited_answers || false
          },
          [SURVEY_FORM_FIELDS.QUESTIONS]: response.data.questions.map(question => {
            return {
              [SURVEY_QUESTION_FIELDS.ID]: question.id,
              [SURVEY_QUESTION_FIELDS.KEY]: question.id,
              [SURVEY_QUESTION_FIELDS.LINEAR_SCALE]: question?.linear_scale,
              [SURVEY_QUESTION_FIELDS.SELECT]: question?.select,
              [SURVEY_QUESTION_FIELDS.OPTIONAL]: question.optional,
              [SURVEY_QUESTION_FIELDS.ORDER]: question.order,
              [SURVEY_QUESTION_FIELDS.TITLE]: question.title,
              [SURVEY_QUESTION_FIELDS.TYPE]: questionTypes.find(type => +type.id === +question.id_type)
            }
          })
        })

      } catch(error) {
        setError(error);
      } finally {
        setLoadingSurvey(false);
      }
    }

    if(surveyID) {
      getData();
    }
  }, [surveyID]);

  return {
    data,
    loadingSurvey,
    error
  }
}